import { useEffect, useState } from "react"
import { IVehicleVisualRecord } from "../../../../../../types/vehicle-visual-record.type";
import { FormikProvider, useFormik } from "formik";
import { DetailsImageVehicleRow } from "../../fields-upload/DetailsImageVehicleRow";
import ModalAddPhotos from "../../vehicle-delivered/ModalAddPhotos/ModalAddPhotos";

type ReturnedDetailsProps = {
  data: IVehicleVisualRecord;
  onClose?: () => void;
}
export default function ReturnedDetails(props: ReturnedDetailsProps) {
  const [vehicleId, setvehicleId] = useState<string | null>(null);
  const [action, setAction] = useState<{ eventName: string, data: IVehicleVisualRecord }>()
  const [data, setData] = useState(props.data);
  const [reload, setReload] = useState(false);

  const reloadPage = () => {
    window.location.reload();
  };
  const formik = useFormik({
    initialValues: {
      devolutionPhotos: props.data.photos.devolutionPhotos,
      // outras propriedades inicializadas aqui
    },
    enableReinitialize: true,
    onSubmit: (values) => { values; },
    // outras opções do Formik aqui
  });

  useEffect(() => {
    if (props.data !== undefined) { props.data && setvehicleId(vehicleId); }
  }, [props.data, vehicleId]);


  useEffect(() => {

    if (!action?.data) {
      return;
    }
    setData(action.data);
    formik.resetForm({
      values: {
        ...formik.values, // mantém os outros campos se quiser
        devolutionPhotos: action.data.photos.devolutionPhotos
      }
    });
    setReload(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [action])


  const isAction = (eventName: string) => action?.eventName === eventName

  return (
    <div className="fixed inset-0 z-10 bg-black bg-opacity-30 flex justify-center items-center p-4">

      <FormikProvider value={formik}>
        <section
          style={{ backgroundColor: 'rgb(179, 175, 175)' }}
          className=" flex flex-col items-center rounded-md shadow-lg max-w-[90%] md:max-w-2xl mx-auto p-4 max-h-[calc(100vh-4rem)] overflow-auto">
          <h2 className="text-2xl font-semibold mb-4">Detalhes da devolução</h2>
          <div className="flex flex-wrap justify-center">
            {data.photos.devolutionPhotos?.map((doc, index) => (
              <div key={index} className={`flex flex-col space-y-2 p-3 my-0 rounded ${index % 2 ? 'bg-gray/5' : 'bg-gray/5'}`}>
                <DetailsImageVehicleRow
                  name={`devolutionPhotos.${index}`}
                  initialData={doc || {}}
                  prefix="devolucao"
                  vehicleId={props.data.vehicleId}
                />
              </div>
            ))}
          </div>
          <div className="w-full sm:w-[70%] h-auto min-h-[200px] p-2 rounded-md shadow-lg mb-8 bg-white/50 text-black overflow-auto">
            <p className="font-bold">Observações: </p>
            <p className="mb-4">{props.data.returnReason}</p>
          </div>

          <div className="flex justify-around w-full">
            <button
              onClick={() => setAction({ eventName: "addFile", data: props.data })}
              className="bg-redPrimary text-white w-34 border-black border-opacity-30 shadow-md relative self-end"
            >
              Adicionar Fotos
            </button>

            <button
              onClick={() => {
                props.onClose && props.onClose();
                reload && reloadPage();
              }}
              className="bg-redPrimary text-white w-24 border-black border-opacity-30 shadow-md relative self-end"
            >
              Fechar
            </button>
          </div>
        </section>
        {(isAction("addFile") && props.data._id) && <ModalAddPhotos vehicleId={data.vehicleId} docType={'devolucao'} onClose={props.onClose as () => void} visualRecordId={props.data._id as string} closeAndUpdate={(data) => setAction(data)}></ModalAddPhotos>}
      </FormikProvider>
    </div>
  )
}

